module.exports = __webpack_public_path__ + "static/media/onboard-4-card-options.3637a3eb.gif";